import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import isClient from 'commons/isClient';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';

import ShippingInfoBlock from '../ShippingInfoBlock';

const PAYPAL_BUTTON_ID = 'paypal-button';

const PaypalOption = ({
  checkout,
  payPalData,
  placeOrderLoading,
  placeOrderWithPayPal,
}) => {
  const payPalBtnRef = useCallback(
    node => {
      if (
        !node ||
        !isClient() ||
        !payPalData?.paypalCheckoutInstance ||
        node.getAttribute('data-paypal-init') ||
        !window.paypal?.FUNDING?.PAYPAL
      )
        return;

      node.innerHTML = '';
      window.paypal
        .Buttons({
          fundingSource: window.paypal.FUNDING.PAYPAL,
          createBillingAgreement: () =>
            payPalData.paypalCheckoutInstance.createPayment({
              flow: 'vault', // Required
            }),
          onInit: () => {
            node.setAttribute('data-paypal-init', 'true');
          },
          onApprove: data =>
            payPalData.paypalCheckoutInstance
              .tokenizePayment(data)
              .then(payload => {
                placeOrderWithPayPal(payload.nonce);
              }),
          onCancel: () => {
            // console.log('PayPal payment canceled', JSON.stringify(data, 0, 2));
          },
          onError: () => {
            // console.error('PayPal error', err);
          },
        })
        .render(`#${PAYPAL_BUTTON_ID}`);
    },
    [payPalData, placeOrderWithPayPal]
  );

  return (
    <div className="PaymentPayNowTab">
      <div className="PaymentPayNowTab__options">
        <div className="relative [&_#paypal-button]:h-[45px] [&_#paypal-button]:w-[20.25rem]">
          <div
            ref={payPalBtnRef}
            id={PAYPAL_BUTTON_ID}
            style={{ display: placeOrderLoading ? 'none' : undefined }}
          />
          {placeOrderLoading && (
            <div className="flex h-[45px] w-[20.25rem] relative rounded items-center [background:#ffc439] justify-center">
              <ProgressLoaderDots />
            </div>
          )}
          <div className="mx-0 my-8 [border-top:1px_solid_#e5e5e5]">
            {checkout && <ShippingInfoBlock checkout={checkout} />}
          </div>
        </div>
      </div>
    </div>
  );
};

PaypalOption.propTypes = {
  checkout: PropTypes.object,
  payPalData: PropTypes.shape({
    paypalCheckoutInstance: PropTypes.shape({
      createPayment: PropTypes.func,
      tokenizePayment: PropTypes.func,
    }),
  }),
  placeOrderLoading: PropTypes.bool,
  placeOrderWithPayPal: PropTypes.func,
};

export default PaypalOption;
